const { getFilmRoomUrl } = require('./src/getFilmRoomUrl');
const FilmRoomQuery = require('./src/FilmRoomQuery');
const { gameTypeMap } = require('./src/getGameType');
const { hitResultMap } = require('./src/getHitResult');
const { getFilmRoomGameUrl } = require('./src/getFilmRoomGameUrl');

module.exports = {
    FilmRoomQuery,
    getFilmRoomUrl,
    gameTypeMap,
    hitResultMap,
    getFilmRoomGameUrl
};
